var ltr6_module_djatour = (function (ltr6_module_djatour) {
    
    ltr6_module_djatour.active = false;
    ltr6_module_djatour.tourContainerElement;

    ltr6_module_djatour.init = function(){

        function scrollToTop(){
          var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          // if(screenwidth<768){
          //   TweenLite.to(window, 0.3, {scrollTo:{y:0},ease:Power1.easeInOut});
          // } else {
          //   var top = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper').offset();
          //   top = top.top - 54;
          //   TweenLite.to(window, 0.3, {scrollTo:{y:top},ease:Power1.easeInOut});
          // }
          var hh = $('body .l-view header').height();
          // console.log(hh-1);
          var top = $('#ltr6-wrapper .ltr6-interactive-radar-wrapper').offset();
          if(screenwidth<768){
            top = top.top - (54+56);
            TweenLite.to(window, 0.3, {scrollTo:{y:top},ease:Power1.easeInOut});
          } else {
            top = top.top - 54;
            top = hh-1;
            console.log('top',top);
            TweenLite.to(window, 0.3, {scrollTo:{y:top},ease:Power1.easeInOut});
          }

        } 



        var tour = [
          {
            // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
            // target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-view',
            // target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-interactive-radar',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>The Logistics Trend Radar</h5><p>This latest edition of DHL’s Logistics Trend Radar provides both developed and new ways to navigate the future of logistics. We hope this guide proves useful for first-time and returning readers alike, enabling discovery, insight, and inspiration from these exciting 40 trends.</p>',
            arrow:'middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function(target){

              scrollToTop();
              // scrollToMobileTop();

              // clear the filters
              ltr6_module_radar.clear_filters();
              //make sure radar view is active
              $('.ltr6-interactive-radar-wrapper .ltr6-radar-top-controls a[data-radar-view="radar"]').trigger('click');
              // fit radar
              ltr6_module_panzoom.smoothFitLandingRadar();
              // ltr6_module_panzoom.panzoomLanding.smoothFitRect({x:376,y:361,width:1575,height:1127},500);
              //make sure sure accordion is open caus we show something later
              var group = $('.ltr6-filter-groups .ltr6-filter-group[data-filter-group="focus_area"]');
              if(!group.hasClass('active')){
                ltr6_module_radar.toggleGroup(group);
              }
            },
            onHide: function(target){
              // console.log('after');
            },
          },
          // green
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-anno-pos-marker',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Social & Business Trends</h5><p>On the left are the <strong style="color:#409d6b;">Social & Business trends in green</strong>, highlighting the top priorities and opportunities for logistics organizations and the communities they strive to serve. These trends reflect the direction of business strategies, new ways of working, and maturing societal values often brought about by technological advancements.</p>',
            arrow:'left-middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            // offset:{x:50,y:50},
            onShow: function (target) {
              target.show();
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-green-trends').fadeIn();
              ltr6_module_panzoom.smoothFitLandingRadar();
              // ltr6_module_panzoom.panzoomLanding.fitRect({x:376,y:361,width:791,height:1127},0,500);
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
              target.css({'top':'996px','left':'999px'});
            },
            onHide: function(target){
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-green-trends').fadeOut();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              ltr6_module_panzoom.panzoomLanding.enableInput();
              target.hide();
            },
          },
          // blue
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-anno-pos-marker',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Technology Trends</h5><p>On the right are the <strong style="color:#6197d6;">Technology trends in blue</strong>, showcasing the development and adoption of new materials, tools, and devices relevant to the logistics industry. These trends respond to the more pressing needs of organizations and societies and are often shaped and accelerated by them.</p>',
            arrow:'right-middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              target.show();
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-blue-trends').fadeIn();
              ltr6_module_panzoom.smoothFitLandingRadar();
              // ltr6_module_panzoom.panzoomLanding.fitRect({x:1167,y:361,width:791,height:1127},500);
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
              target.css({'top':'996px','left':'999px'});
            },
            onHide: function(target){
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-blue-trends').fadeOut();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              ltr6_module_panzoom.panzoomLanding.enableInput();
              target.hide();
            },
          },
          // red center dot 
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-anno-pos-marker',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Adoption Timeline</h5><p>The <strong class="color-red-500">red center dot</strong> represents the logistics industry as a whole today. The Adoption timeline signifies when a trend is anticipated to become a non-trend, or the standard way of operating, within a 10-year span.</p>',
            arrow:'bottom-middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              target.show();
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-realization').fadeIn();
              ltr6_module_panzoom.fitLandingRadar();
              ltr6_module_panzoom.panzoomLanding.center();
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
              target.css({'top':'996px','left':'999px'});
            },
            onHide: function(target){
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-realization').fadeOut();
              ltr6_module_panzoom.panzoomLanding.enableInput();
              target.hide();
            },
          },
          // realized within 5 years
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-anno-pos-marker',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Adoption of < 5 Years</h5><p>Trends in the <strong>inner half</strong> of the Logistics Trend Radar will be adopted within 5 years, as they feature more scalable use cases and more applicable implementation opportunities in supply chains today.</p>',
            arrow:'right-middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              target.show();
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-realization-low').fadeIn();
              ltr6_module_panzoom.fitLandingRadar();
              ltr6_module_panzoom.panzoomLanding.center();
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
              target.css({'top':'1000px','left':'1187px'});
            },
            onHide: function(target){
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-realization-low').fadeOut();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              ltr6_module_panzoom.panzoomLanding.enableInput();
              target.hide();
            },
          },
          // realized within 5 to 10 years
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-anno-pos-marker',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Adoption of 5-10 Years</h5><p>Meanwhile, trends in the <strong>outer half</strong> will be adopted within 5 to 10 years, as integral technologies and business cases are often not yet fully developed and, right now, may be undergoing testing and verification.</p>',
            arrow:'right-middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              target.show();
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-realization-high').fadeIn();
              ltr6_module_panzoom.fitLandingRadar();
              ltr6_module_panzoom.panzoomLanding.center();
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
              target.css({'top':'1000px','left':'1537px'});
            },
            onHide: function(target){
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-realization-high').fadeOut();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              ltr6_module_panzoom.panzoomLanding.enableInput();
              target.hide();
            },
          },
          // Impact bar
          {
            target : '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-anno-pos-marker',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Impact Scale</h5><p>The Impact scale starts from both ends of the Logistics Trend Radar and spans its curvature until meeting at the top. It reflects how much a trend will change both the inner workings and face of supply chains for management, workers, and customers. Together, the left and the right sides of the radar are divided into eight slices, four on each side.</p>',
            arrow:'top-middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              target.show();
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-impact-scale').fadeIn();
              ltr6_module_panzoom.fitLandingRadar();
              ltr6_module_panzoom.panzoomLanding.center();
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
              target.css({'top':'214px','left':'998px'});
            },
            onHide: function(target){
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-impact-scale').fadeOut();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              ltr6_module_panzoom.panzoomLanding.enableInput();
              target.hide();
            },
          },
          // high impact
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-anno-pos-marker',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>High Impact</h5><p>Trends with High Impact involve applications that are potentially disruptive to supply chains. These are in the <strong>highest slices</strong> of the radar.</p>',
            arrow:'top-middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              target.show();
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-high-impact').fadeIn();
              ltr6_module_panzoom.fitLandingRadar();
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
              target.css({'top':'214px','left':'998px'});
            },
            onHide: function(target){
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-high-impact').fadeOut();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              ltr6_module_panzoom.panzoomLanding.enableInput();
              target.hide();
            },
          },
          // low impact
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-anno-pos-marker',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Low Impact</h5><p>Trend with Low Impact encompass evolutionary changes with incremental improvements. These are in the <strong>lowest slices</strong> of the radar.</p>',
            arrow:'bottom-middle',
            position:'middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              target.show();
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-low-impact').fadeIn();
              ltr6_module_panzoom.fitLandingRadar();
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
              target.css({'top':'1764px','left':'998px'});
            },
            onHide: function(target){
              $('.ltr6-interactive-radar-wrapper .ltr6-anno-low-impact').fadeOut();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              ltr6_module_panzoom.panzoomLanding.enableInput();
              target.hide();
            },
          },
          // 3 Perspectives
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Perspectives &amp; Lenses</h5><p>In total, there are <strong>3 perspectives</strong>, each reflecting different ways in which the world and its trends are organized and perceived. Each perspective consists of <strong>6 lenses</strong> that further refine and classify a particular outlook. In turn, each lens highlights the trends that are at the core and pertinent to the category.</p>',
            arrow:'left-middle',
            position:'right-top',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
              if(screenwidth<768){
                ltr6_module_radar.openMobileFilterMenu();
              }
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex',1011);
            },
            onHide: function(target){
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex','');
            },
          },
          // Focus Areas
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Focus Areas Perspective</h5><p>The Focus Areas perspective frames trends on both sides of the Logistics Trend Radar using lenses that reflect various strategic goals and opportunities in logistics and supply chains.</p>',
            arrow:'left-middle',
            position:'right-top',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            offset:{x:0,y:90},
            onShow: function (target) {
              //make sure sure accordion is open caus we show something later
              var group = $('.ltr6-filter-groups .ltr6-filter-group[data-filter-group="focus_area"]');
              if(!group.hasClass('active')){
                ltr6_module_radar.toggleGroup(group);
              }
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex',1011);
            },
            onHide: function(target){
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex','');
            },
          },
          // Trend Clusters
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Trend Clusters Perspective</h5><p>The Trend Clusters perspective filters the social and business trends and technology trends with lenses that represent different technology groups.</p>',
            arrow:'left-middle',
            position:'right-top',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            offset:{x:0,y:90+42},
            onShow: function (target) {
              //make sure sure accordion is open caus we show something later
              var group = $('.ltr6-filter-groups .ltr6-filter-group[data-filter-group="trend_cluster"]');
              if(!group.hasClass('active')){
                ltr6_module_radar.toggleGroup(group);
              }
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex',1011);
            },
            onHide: function(target){
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex','');
            },
          },
          // Sectors
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Sectors Perspective</h5><p>The Sectors perspective highlights trends across the Logistics Trend Radar using lenses that correspond to different industrial sectors with substantial and distinct supply chains.</p>',
            arrow:'left-middle',
            position:'right-top',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            offset:{x:0,y:90+42+42},
            onShow: function (target) {
              //make sure sure accordion is open caus we show something later
              var group = $('.ltr6-filter-groups .ltr6-filter-group[data-filter-group="sector"]');
              if(!group.hasClass('active')){
                ltr6_module_radar.toggleGroup(group);
              }
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex',1011);
            },
            onHide: function(target){
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex','');
            },
          },
          // Perspectives &amp; Lenses
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters label[data-filter-name="energy"]',
            // mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-filters label[data-filter-name="energy"]',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Filter Trends</h5><p>You can filter trends on the Trend Radar by selecting on a lens.</p>',
            arrow:'left-middle',
            position:'right-middle',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex',1011);
            },
            onHide: function(target){
              // $('.ltr6-interactive-radar-wrapper .ltr6-filters-col').css('zIndex','');
            },
          },
          // Explore Trends
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-node[data-trend="wearable-sensors"]',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            content: '<h5>Explore Trends</h5><p>The Trend Radar is not the only thing to see – start exploring the trends themselves! There are 40 different pages, one per trend, describing in depth key opportunities, challenges, use cases, and some facts and figures. This gives a better understanding of each trend as well as its impact and realization in the logistics industry and supply chains.</p><p>You can access a trend page by selecting its trend name on the Trend Radar.</p>',
            arrow:'bottom-middle',
            position:'top-left',
            mobile_arrow:'top-middle',
            mobile_position:'bottom-middle',
            onShow: function (target) {

              var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
              if(screenwidth<768){
                ltr6_module_radar.closeMobileFilterMenu();
              }
              // target.css({'top':'996px','left':'999px'});

              ltr6_module_panzoom.fitLandingRadar();
              // ltr6_module_panzoom.panzoomLanding.center();
              // var panzoomOverlay = $('.ltr6-interactive-radar-wrapper .ltr6-radar-panzoom-overlay');
              // panzoomOverlay.addClass('active');
              var scale = ltr6_module_panzoom.panzoomLanding.scale;
              ltr6_module_panzoom.panzoomLanding.disableInput();
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex',1011);
            },
            onHide: function(target){
              // var panzoomOverlay = $('.ltr6-interactive-radar-wrapper .ltr6-radar-panzoom-overlay');
              // panzoomOverlay.removeClass('active');
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-view').css('zIndex','');
              ltr6_module_panzoom.panzoomLanding.enableInput();
            },
          },
          // GRID VIEW SWITCH
          // {
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-top-right-controls .ltr6-radar-view-button-group',
          //   mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-top-right-controls .ltr6-radar-view-button-group',
          //   content: '<h5>Switch Views</h5><p>Sometimes, it can be easier to interpret trends in a different layout. Grid View presents trends by their type and in alphabetical order. Trends can still be filtered by their perspective and lens classification.</p><p>You can toggle between Radar View and Grid View by clicking the buttons here.</p>',
          //   arrow:'right-top',
          //   position:'left-middle',
          //   mobile_arrow:'top-right',
          //   mobile_position:'bottom-left',
          //   onShow: function (target) {
          //     scrollToTop();

          //     // $('.ltr6-interactive-radar-wrapper .ltr6-radar-top-controls').css('zIndex',1011);
          //   },
          //   onHide: function(target){
          //     $('.ltr6-interactive-radar-wrapper .ltr6-radar-top-controls a[data-radar-view="radar"]').trigger('click');
          //     //set top controls back to normal
          //     // $('.ltr6-interactive-radar-wrapper .ltr6-radar-top-controls').css('zIndex',1);
          //   },
          // },
          // radar menu
          {
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-interactive-radar',
            highlight: '#ltr6-wrapper .ltr6-navigation a.ltr6-nav-radar',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-interactive-radar',
            content: '<h5>Radar Always Accessible</h5><p>Whether on the homepage or a trend page, the Trend Radar is always readily accessible to you! This means trends can be explored without always having to return to the homepage.</p><p>You can access the Trend Radar here anytime on the navigation bar.</p>',
            arrow:'middle',
            position:'middle',
            mobile_arrow:'middle',
            mobile_position:'middle',
            onShow: function (target) {
              scrollToTop();

              $('#ltr6-navigation').css('opacity',1);
              $('.l-view header').css('opacity',1);
              // $('#ltr6-wrapper .ltr6-navigation').css('zIndex',1011);
            },
            onHide: function(target){
              // $('#ltr6-wrapper .ltr6-navigation').css('zIndex',1001);
            },
          },
          // end
          {
            // target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-top-right-controls .ltr6-tutorial-link',
            // mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-top-right-controls .ltr6-tutorial-link',
            // content: '<h5>End of Tour</h5><p>We hope this guide was useful. Have fun exploring DHL’s Logistics Trend Radar!</p>',
            // arrow:'top-right',
            // position:'bottom-middle',
            // mobile_arrow:'top-middle',
            // mobile_position:'bottom-middle',


            // target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-interactive-radar',
            target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-interactive-radar',
            // mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper',
            mobile_target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-interactive-radar',
            content: '<h5>End of Tour</h5><p>We hope this guide was useful. Have fun exploring DHL’s Logistics Trend Radar!</p>',
            arrow:'middle',
            position:'middle',
            mobile_arrow:'middle',
            mobile_position:'middle',



            onShow: function (target) {
              scrollToTop();
              
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-top-controls').css('zIndex',1011);
            },
            onHide: function(target){
              // $('.ltr6-interactive-radar-wrapper .ltr6-radar-top-controls').css('zIndex',1);
            },
          },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'top-middle',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'top-right',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'bottom-left',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'bottom-middle',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'bottom-right',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   // target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-view',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'left-top',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'left-middle',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'left-bottom',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'right-top',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'right-middle',
          //   position:'middle',
          // },
          // {
          //   // target: '#ltr6-wrapper a[data-ltr6-panzoom-action="zoom_in"]',
          //   target: '#ltr6-wrapper .ltr6-interactive-radar-wrapper .ltr6-radar-panzoom .ltr6-node[data-trend="digital-marketplaces"]',
          //   arrow:'right-bottom',
          //   position:'middle',
          // },
        ];

        // $('body').append('<div style="display:block;position:absolute;z-index:99999999;top:50px;left:50px;width:100px;height:40px;background:magenta;"></div>');
        var tourPopup = $('<div class="ltr6-tour-popup"><div class="ltr6-tour-popup-arrow"></div><div class="ltr6-tour-popup-content"><div class="ltr6-tour-popup-text"></div><div class="ltr6-tour-buttons"><a href="#" class="ltr6-tour-end">End Tour</a><a href="#" class="ltr6-tour-prev">Prev</a><a href="#" class="ltr6-tour-next has-icon icon-right icon-chevron-forward">Next</a></div></div></div>');
        // $('body').append(tourPopup);

        ltr6_module_djatour.tourContainerElement = $('#ltr6-wrapper');
        ltr6_module_djatour.tourContainerElement.append(tourPopup);

        
        
        // var marker = $('<div style="background:cyan;display:block;position:absolute;top:100px;left:100px;margin-left:-2px;margin-top:-2px;width:4px;height:4px;z-index:999999;"></div>');
        // $('body').append(marker);
        
        // console.log('tour.length',tour.length);

        var tourStep = 0;

        var tourPopupPositions = [
          'top-left',
          'top-middle',
          'top-right',
          'bottom-left',
          'bottom-middle',
          'bottom-right',
          'left-top',
          'left-middle',
          'left-bottom',
          'right-top',
          'right-middle',
          'right-bottom',
          'middle',
        ];
        // var arrows = [
        //   'left','right','middle',
        //   'top','middle','bottom',
        // ];

        // function get
        function endTour(){

        }
        function startTour(){

        }
        function scrollIntoViewIfNeeded(target) { 
            if (target.getBoundingClientRect().bottom > window.innerHeight) {
                target.scrollIntoView(false);
            }

            if (target.getBoundingClientRect().top < 0) {
                target.scrollIntoView();
            } 
        }


        // start tour
        $('#ltr6-wrapper').on('click', '.ltr6-tutorial-link', function(event) {
          event.preventDefault();
          // console.log(tour);
          // $('body').addClass('ltr6-tour-modifier');
          if(tourStep==0){
            tourStep = 0; //??
            runStep(tourStep);
          }
          $('#ltr6-wrapper .ltr6-tutorial-overlay').show();
          $('#ltr6-wrapper').addClass('ltr6-tour-active');
        });



        // next
        $('body').on('click', '.ltr6-tour-popup .ltr6-tour-next', function(event) {
          event.preventDefault();

          tourStep ++;
          runStep(tourStep);
        });
        // prev
        $('body').on('click', '.ltr6-tour-popup .ltr6-tour-prev', function(event) {
          event.preventDefault();

          tourStep --;
          runStep(tourStep);
        });
        // end
        $('body').on('click', '.ltr6-tour-popup .ltr6-tour-end', function(event) {
          event.preventDefault();
          var tourItem = tour[tourStep];
          var target = $(tourItem.target).first();
          if(typeof tourItem.onHide !== "undefined"){
            tourItem.onHide(target);
          }
          $('#ltr6-wrapper').removeClass('ltr6-tour-active');
          $('.ltr6-tour-modifier').removeClass('ltr6-tour-modifier');
          tourPopup.hide();
          tourStep = 0;
          ltr6_module_djatour.active = false;

          // ltr6_module_panzoom.smoothFitLandingRadar();
          ltr6_module_panzoom.panzoomLanding.smoothCenter();
          $('#ltr6-wrapper .ltr6-tutorial-overlay').hide();
          // $('#ltr6-wrapper .ltr6-tutorial-link').show();
        });

        // tourPopup.hide();


        var lastStep = null;

        function runStep(tourStep){
            ltr6_module_djatour.active = true;

            tourPopup.hide();

            if(lastStep){
              var prevTourItem = tour[lastStep];
              var prevTarget = $(prevTourItem.target).first();
              if(typeof prevTourItem.onHide !== "undefined"){
                prevTourItem.onHide(prevTarget);
              }
            }

            // $('#ltr6-wrapper').addClass('ltr6-tour-in-progress');


            // get position on screen
            var tourItem = tour[tourStep];
            var target = $(tourItem.target).first();

            if(typeof tourItem.onShow !== "undefined"){
              tourItem.onShow(target);
            }

            var pos = target.offset();

            //account for it being in an element, except the fixed position ones
            // if (tourStep != 15 && tourStep != 16) {
              var parentOffset = ltr6_module_djatour.tourContainerElement.parent().offset();
              pos.left -= parentOffset.left;
              // pos.top -= parentOffset.top;
            // }

            if(!$('#ltr6-wrapper .ltr6-tour-active').hasClass('is-fixed')){
              // $('#ltr6-wrapper .ltr6-tour-popup').css('margin-top','0rem');
              pos.top -= 124.2;
            }



            $('.ltr6-tour-modifier').removeClass('ltr6-tour-modifier');
            if(tourItem.highlight){
              $(tourItem.highlight).first().addClass('ltr6-tour-modifier');
            } else {
              target.addClass('ltr6-tour-modifier');
            }

          // EXCEPTION FOR 15
          // if (tourStep == 15) {
          //   target = ltr6_module_djatour.tourContainerElement;
          //   // var scrollTop = $(window).scrollTop();
          //   // pos.top -= scrollTop;
          // }

          // // EXCEPTION FOR 15
          // if (tourStep == 16) {
          //   target = ltr6_module_djatour.tourContainerElement;
          //   // var scrollTop = $(window).scrollTop();
          //   // pos.top -= scrollTop;
          // }
            var tourItemPosition = tourItem.position;
            var tourItemArrow = tourItem.arrow;

            var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (screenwidth < 990) {
              target = $(tourItem.mobile_target).first();
              tourItemArrow = tourItem.mobile_arrow;//'top-middle';
              tourItemPosition = tourItem.mobile_position;//'bottom-middle';
              pos = target.offset();
            }
            if(screenwidth<768){
              target = $(tourItem.mobile_target).first();
              tourItemArrow = tourItem.mobile_arrow;//'top-middle';
              tourItemPosition = tourItem.mobile_position;//'bottom-middle';
              // target = $('.ltr6-interactive-radar-wrapper');
              pos = target.offset();
              // if(tourItem.mobile_target=='#ltr6-wrapper .ltr6-interactive-radar-wrapper') pos.top -= 100;
              // if(tourItem.mobile_target=='#ltr6-wrapper .ltr6-interactive-radar-wrapper') pos.left = 0;
            }

            // var pos = target.offset();
            // var parentScale = target[0].style.transform.match(/scale\((\d*\.?\d*)/)[1];
            // console.log('parentScale',parentScale-1);
            // console.log('tourStep',tourStep);
            // console.log('tourItem',tourItem);
            // console.log('target',target);
            // console.log('pos',pos);


            if(!$('#ltr6-wrapper .ltr6-tour-active').hasClass('is-fixed') && screenwidth<990){
              // $('#ltr6-wrapper .ltr6-tour-popup').css('margin-top','0rem');
              pos.top -= 124.2;
            }

            tourPopup.removeClass(tourPopupPositions);
            tourPopup.removeClass('force-middle');
            tourPopup.addClass(tourItemArrow);


            var posTop = pos.top;
            var posLeft = pos.left;
            var targetRect = target[0].getBoundingClientRect();
            var height = targetRect.height;
            var width = targetRect.width;

              // console.log('height',height);
              // console.log('width',width);
              // console.log('pos',pos);
              // console.log('posTop',posTop);
              // console.log('posLeft',posLeft);



            if(tourItemPosition=='top-left'){
              // posLeft += (width*0.5);
            } 
            if(tourItemPosition=='top-middle'){
              posLeft += (width*0.5);
            } 
            if(tourItemPosition=='top-right'){
               posLeft += (width);
            }
            if(tourItemPosition=='bottom-left') {
              posTop += (height);
              // posLeft += (width);
            }
            if(tourItemPosition=='bottom-middle') {
              posTop += (height);
              posLeft += (width*0.5);
            }
            if(tourItemPosition=='bottom-right') {
              posTop += (height);
              posLeft += (width);
            }
            if(tourItemPosition=='left-top') {
              // posTop += (width);
            }
            if(tourItemPosition=='left-middle') {
              posTop += (height*0.5);
            }
            if(tourItemPosition=='left-bottom') {
              posTop += (height);
            }
            if(tourItemPosition=='right-top') {
              posLeft += (width);
              // posTop += (width);
            }
            if(tourItemPosition=='right-middle') {
              posLeft += (width);
              posTop += (height*0.5);
            }
            if(tourItemPosition=='right-bottom') {
              posLeft += (width);
              posTop += (height);
            }
            if(tourItemPosition=='middle' || tourItem.position=='center') {
              posLeft += (width*0.5);
              posTop += (height*0.5);
            }


            if(screenwidth<768) {
              tourPopup.addClass('force-middle');
              targetRect = $('.ltr6-interactive-radar-wrapper')[0].getBoundingClientRect();
              // height = targetRect.height;
              width = targetRect.width;
              // posLeft = 0;
              posLeft = (width*0.5) + 21; // 21 is to account for the way its now centered using calc(100vw - 4.2rem)
              // posTop -= 100;
              if(tourItem.mobile_target=='#ltr6-wrapper .ltr6-interactive-radar-wrapper') posTop -= 100;
            }  



            // offset
            if(tourItem.hasOwnProperty('offset') && screenwidth>=990){
              posLeft += tourItem.offset.x;
              posTop += tourItem.offset.y;
            }

            tourPopup.find('.ltr6-tour-popup-text').html(tourItem.content);

            $('.ltr6-tour-prev',tourPopup).removeClass('disabled');
            $('.ltr6-tour-next',tourPopup).removeClass('disabled');
            if(tourStep==(tour.length-1)){
              $('.ltr6-tour-next',tourPopup).addClass('disabled');
            }
            if(tourStep==0){
              $('.ltr6-tour-prev',tourPopup).addClass('disabled');
            }
            // console.log('pos',pos);
            // console.log('posTop',posTop);
            // console.log('posLeft',posLeft);
            // console.log('width',width);
            tourPopup.css('top',Math.floor(posTop));
            tourPopup.css('left',Math.floor(posLeft));

            tourPopup.delay(0).fadeIn(300);
            tourPopup.attr('ltr-tour-step',tourStep);

            // scrollIntoViewIfNeeded(tourPopup[0]);
            setTimeout(function(){
              tourPopup.scrollintoview();
            },10);
            lastStep = tourStep;
        }
        
        // function keepFixedPositionToHeader(){
        //   console.log(tourStep);
        //   if(tourStep == 15 || tourStep == 16){

        //   }
        // }
        
        // $(window).on('scroll', keepFixedPositionToHeader);

        // tourStep = 17;

        // runStep(tourStep);
        // tourStep ++;

        // var tourTimer = setInterval(function(){
        //   if(tourStep >= tour.length) {
        //     tourStep = 0;
        //     // clearInterval(tourTimer);
        //     // return false;
        //   }
        //   runStep(tourStep);
        //   tourStep ++;
        // },1000);

    };

    return ltr6_module_djatour;
}(ltr6_module_djatour || {}));